var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M16 32.2559C24.8366 32.2559 32 25.0924 32 16.2559C32 7.4193 24.8366 0.255859 16 0.255859C7.16344 0.255859 0 7.4193 0 16.2559C0 25.0924 7.16344 32.2559 16 32.2559Z",
    fill: "#0A1E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.2559C15.433 15.2559 17 13.6889 17 11.7559C17 9.82286 15.433 8.25586 13.5 8.25586C11.567 8.25586 10 9.82286 10 11.7559C10 13.6889 11.567 15.2559 13.5 15.2559Z",
    stroke: "#0A1E5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47852 23.6084V21.9554C8.47852 21.0789 8.82672 20.2382 9.44653 19.6184C10.0663 18.9986 10.907 18.6504 11.7835 18.6504H15.0895C15.9661 18.6504 16.8067 18.9986 17.4265 19.6184C18.0463 20.2382 18.3945 21.0789 18.3945 21.9554V23.6084",
    stroke: "#0A1E5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2207 8.8418C19.9301 9.02501 20.5585 9.43875 21.0071 10.018C21.4558 10.5972 21.6992 11.3091 21.6992 12.0418C21.6992 12.7745 21.4558 13.4864 21.0071 14.0656C20.5585 14.6448 19.9301 15.0586 19.2207 15.2418",
    stroke: "#0A1E5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.353 23.6084V21.9554C23.3488 21.2259 23.1034 20.5184 22.6549 19.943C22.2065 19.3676 21.5804 18.9567 20.874 18.7744",
    stroke: "#0A1E5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCircle);
export default __webpack_public_path__ + "static/media/users-circle.e9bae79d596bf80c99086d5b7328f5e7.svg";
export { ForwardRef as ReactComponent };